export class ModalDetalhesErroUploadController {
  constructor($scope, $uibModalInstance, upload) {
    'ngInject';

    this.errorDetailList = upload.retorno.error.errorDetailList;

    $scope.cancelar = () => {
      $uibModalInstance.dismiss('cancel');
    }
  }
}
